<template>
    <section class="hero bng-temporary-password-reset">
        <div class="hero-body">
            <div class="container">
                <div class="column">
                    <div class="card">
                        <div class="card-content">
                            <div class="title-bar">
                                <p
                                    class="title"
                                >{{"components.pages.temporary-password-reset.title" | translate}}</p>
                                <a class="button is-outlined" @click="logout">
                                    <span class="icon is-small has-text-grey">
                                        <i class="fas fa-sign-out-alt has-color-green"></i>
                                    </span>
                                    <span>{{"components.pages.temporary-password-reset.logout" | translate}}</span>
                                </a>
                            </div>

                            <form
                                @submit.prevent="submit()"
                                :class="{ 'is-loading' : loading }"
                                role="form"
                            >
                                <!-- Password input-->
                                <div class="field">
                                    <div class="control has-icons-left has-icons-right">
                                        <input
                                            v-model.trim="password"
                                            v-validate="'required|min:4|max:20'"
                                            data-vv-name="password"
                                            data-vv-validate-on="input"
                                            :placeholder="'components.pages.temporary-password-reset.password' | translate"
                                            class="input is-large"
                                            :type="showPassword ? 'text' : 'password'"
                                            maxlength="20"
                                            ref="password"
                                        />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                        <a
                                            class="icon is-small is-right is-clickable"
                                            @click="toggleShowPassword('password')"
                                        >
                                            <span v-show="!showPassword">
                                                <i class="far fa-eye-slash"></i>
                                            </span>
                                            <span v-show="showPassword">
                                                <i class="far fa-eye"></i>
                                            </span>
                                        </a>
                                        <p
                                            class="help is-danger"
                                            v-if="errors.has('password:required')"
                                        >{{"components.pages.temporary-password-reset.validation.password required" | translate}}</p>
                                        <p
                                            class="help is-danger"
                                            v-if="errors.has('password:min')"
                                        >{{"components.pages.temporary-password-reset.validation.password min length" | translate}}</p>
                                        <p
                                            class="help is-danger"
                                            v-if="errors.has('password:max')"
                                        >{{"components.pages.temporary-password-reset.validation.password max length" | translate}}</p>
                                        <p
                                            class="help is-danger"
                                            v-if="error"
                                        >{{"components.pages.temporary-password-reset.validation.general error" | translate}}</p>
                                    </div>
                                </div>

                                <!-- Agreement input-->
                                <div class="field center-field">
                                    <div class="control">
                                        <label class="checkbox">
                                            <input
                                                v-model="agreement"
                                                data-vv-name="agreement"
                                                data-vv-validate-on="change"
                                                v-validate="'required'"
                                                type="checkbox"
                                            />
                                            <span>
                                                {{'components.pages.temporary-password-reset.agreement' | translate}}
                                                <router-link
                                                    :to="{ name: 'terms-and-conditions' }"
                                                >{{'components.pages.temporary-password-reset.agreement rules' | translate}}</router-link>
                                            </span>
                                        </label>
                                        <p
                                            class="help is-danger"
                                            v-if="errors.has('agreement:required')"
                                        >{{"components.pages.temporary-password-reset.validation.agreement required" | translate}}</p>
                                    </div>
                                </div>

                                <!-- Submit-->
                                <button
                                    :class="[{ 'is-loading': loading }, 'card-footer-item button is-warning is-large']"
                                >
                                    <span
                                        v-if="!loading"
                                    >{{"components.pages.temporary-password-reset.confirm" | translate}}</span>
                                    <span class="icon" v-if="loading">
                                        <i class="fas fa-circle-notch fa-pulse"></i>
                                    </span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from 'vue';

import authService from '../../../../../../_common/services/authentication.service';

export default {
    name: 'temporary-password-reset',
    $_veeValidate: { validator: 'new' },
    data() {
        return {
            showPassword: false,
            error: null,
            loading: false,
            password: null,
            agreement: false
        };
    },
    async mounted() {},
    methods: {
        toggleShowPassword(ref) {
            this.showPassword = !this.showPassword;
            setTimeout(() => this.$refs[ref].focus());
        },
        async submit() {
            await this.$validator.validateAll();
            if (this.errors.any() || this.loading) return;

            this.errors.clear();
            this.error = false;
            this.loading = true;

            try {
                await authService.resetTemporaryPassword(this.password);
                await Vue.state.player.reload();
                await Vue.router.teleport.home();
            } catch (ex) {
                console.error(ex);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        async logout() {
            await Vue.state.player.logout();
            await Vue.router.teleport.home();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/temporary-password-reset/temporary-password-reset.vue